'use strict';

let $, $window, $body, $globalNavi;

const breakPoint = 768;
const particlesSettingPath = `//${location.host}/wp-content/themes/me-corporate/assets/particlesjs-config.json`;
const LISTENERS = {
	animationEnd: 'animationend webkitAnimationEnd oAnimationEnd mozAnimationEnd',
	transitionEnd: 'transitionend webkitTransitionend oTransitionend mozTransitionend'
};

activate();

function activate() {
	jQuery(() => {
		$ = jQuery;
		$window = $(window);
		$body = $('body');
		initMenu();
		initPageMoving();
		initScrollDown();
	});
}

function initMenu() {
	$globalNavi = $('.me-global-navi');
	initSearchField();
	if (window.innerWidth >= breakPoint) {
		return;
	}
	const menuOpenButtonDom = `
		<div class="me-menu-open-button">
			<span class="fa fa-bars fa-2x"></span>
		</div>
	`;
	const globalNaviFullDom = `
		<div class="me-global-navi-full animated">
			<span class="me-menu-close-button fa fa-close fa-2x"></span>
		</div>
	`;
	$globalNavi.append(menuOpenButtonDom);
	$body.append(globalNaviFullDom);
	const $globalNaviFull = $('.me-global-navi-full');
	$globalNavi.find('ul').appendTo('.me-global-navi-full');
	$('.me-menu-open-button').on('click', () => {
		$globalNaviFull
			.addClass('fadeIn')
			.toggleClass('active')
			.one(LISTENERS.animationEnd, function () {
				$(this).removeClass('fadeIn');
			});
	});
	$('.me-menu-close-button').on('click', () => {
		$globalNaviFull
			.addClass('fadeOut')
			.one(LISTENERS.animationEnd, function () {
				$(this).removeClass('fadeOut active');
			});
	});
}

function initSearchField() {
	if ($body.hasClass('search')) {
		$globalNavi.addClass('me-search-active');
	}
	$('.search-submit').on('touchend', (e) => {
		e.preventDefault();
		$globalNavi.toggleClass('me-search-active');
	});
	$('.search-form')
		.on('mouseenter', (e) => $globalNavi.addClass('me-search-active'))
		.on('mouseleave', (e) => $globalNavi.removeClass('me-search-active'))
		.on('submit', (e) => {
			if ($(e.currentTarget).find('.search-field').val() === '') {
				e.preventDefault();
			}
		});
}

function initPageMoving() {
	$window
		.one('load', () => {
			$body
				.addClass('active')
				.one(LISTENERS.transitionEnd, function () {
					if (!$(this).hasClass('home')) {
						return;
					}
					$('.me-main-visual').addClass('active');
				});
		})
		.one('beforeunload', () => {
			$body.removeClass('active');
			if (window.innerWidth >= breakPoint) {
				return;
			}
			$('.me-menu-open-button').off();
			$('.me-menu-close-button').off();
		});
}

function initScrollDown() {
	if (!$body.hasClass('home')) return;
	setTimeout(() => {
		$('.me-scroll').addClass('active');
	}, 2000);
}



// WEBPACK FOOTER //
// ./assets/src/scripts/script.js